import { DEFAULT_LIMIT } from '../constants/pagination';
import { IGetProjectsListV2ResponseSchema } from '../repositories/countryside-constructors/entities/v2_entities/GetProjectsListV2ResponseSchema';
import { IBuildersProjectsData } from '../types/buildersProjects';

export const prepareBuildersProjectsData = (response: IGetProjectsListV2ResponseSchema): IBuildersProjectsData => {
  return {
    page: response.page || 0,
    limit: response.limit || DEFAULT_LIMIT,
    total: response.total || 0,
    projectsList: response.projectsList,
    location: response.location,
    breadcrumbs: response.breadcrumbs,
  };
};
